import { IFieldValue } from './../../interfaces/state/index';
import isNil from 'lodash/isNil';
import { ITabField, areDatesEqual, RESOURCE_FIELD_TYPE } from '@logicmanager/common';

export function formHasBeenEdited(fieldValues: IFieldValue, fieldMeta: ITabField[]): boolean {
    for (const id in fieldValues) {
      const metaField: ITabField = fieldMeta[id];
      const currentValue: string = fieldValues[id].value;
      const metaValue: string = metaField && metaField.value;
      /* if metaValue is null, undefined, or empty string,
      and currentValue is defined */
      if (!metaValue && (!isNil(currentValue) && currentValue !== '')) {
        return true;
      }
      /* if metaValue is defined and currentValue is not equal to metaValue,
      i.e. user has changed currentValue */
      if (metaValue && currentValue !== metaValue) {
        /* Case #1: If field type is DATE, need to do a Date comparison
        using momentJS. If Dates are not equal, form has been edited
        Case #2: If one value is a number and other is a string, convert both to string and compare.
        If not equal, form has been edited
        */
        if ((metaField.fieldType === RESOURCE_FIELD_TYPE.DATE && !areDatesEqual(metaValue, currentValue)) ||
          (metaValue.toString() !== currentValue.toString())) {
          return true;
        }
      }
    }
    return false;
  }
